import {
  readContactFormHasErrors,
  readContactFormSuccess,
} from '../utils/shopifyContactForm';

const MIN_PHONE_DIGITS = 10;
const FINAL_STEP       = 4;
const SESSION_KEY      = 'rhHire';
const UK_POSTCODE_RE   = /^[A-Z]{1,2}[0-9][0-9A-Z]?\s*[0-9][A-Z]{2}$/i;
const FIELD = {
  FIRST_NAME: 'rh-first-name',
  LAST_NAME:  'rh-last-name',
  EMAIL:      'rh-email',
  PHONE:      'rh-phone',
  POSTCODE:   'rh-postcode',
  COMMENTS:   'rh-comments',
};

const initStepReview = () => {
  const stepEl = document.querySelector('#rh-step-4:not([data-rh-init])');
  if (!stepEl) return;
  stepEl.dataset.rhInit = 'true';

  // Liquid rendered the success state — form.posted_successfully? was true on this page load.
  // Clear the session and update the progress bar, nothing else to wire up.
  if (document.getElementById('rh-success')) {
    sessionStorage.removeItem(SESSION_KEY);
    if (window.updateProgress) window.updateProgress(FINAL_STEP);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }

  const translations = JSON.parse(document.getElementById('rh-translations').textContent);

  function populateSummary() {
    const hire = JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}');

    if (hire.days)         document.getElementById('rhs-days').textContent     = hire.days;
    if (hire.startDisplay) document.getElementById('rhs-start').textContent    = hire.startDisplay;
    if (hire.endDisplay)   document.getElementById('rhs-end').textContent      = hire.endDisplay;
    if (hire.quantity)     document.getElementById('rhs-quantity').textContent = hire.quantity;

    const accWrap = document.getElementById('rhs-accessories');
    if (hire.accessories && accWrap) {
      accWrap.innerHTML = '';
      Object.keys(hire.accessories).forEach(function (key) {
        const row   = document.createElement('div');
        row.className = 'flex justify-between items-start mb-2 text-sm text-[#333] gap-2';
        const label = key.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        row.innerHTML =
          '<span class="text-[#666] shrink-0">' + label + '</span>' +
          '<span class="font-[700] text-[#0d2d6b]">' + hire.accessories[key] + '</span>';
        accWrap.appendChild(row);
      });
    }
  }

  function buildEmailBody(hire, firstName, lastName, phone, postcode, comments) {
    const lines = [
      '=== RADIO HIRE ENQUIRY ===',
      '',
      'Name:     ' + firstName + ' ' + lastName,
      'Phone:    ' + phone,
      'Postcode: ' + postcode,
      '',
      '--- Hire Details ---',
      'Start:    ' + (hire.startDisplay || ''),
      'End:      ' + (hire.endDisplay   || ''),
      'Duration: ' + (hire.days         || '') + ' days',
      'Quantity: ' + (hire.quantity     || '') + ' radios',
      '',
      '--- Accessories ---'
    ];

    if (hire.accessories) {
      Object.keys(hire.accessories).forEach(function (key) {
        const label = key.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        lines.push(label + ': ' + hire.accessories[key]);
      });
    }

    if (comments) {
      lines.push('');
      lines.push('--- Additional Comments ---');
      lines.push(comments);
    }

    return lines.join('\n');
  }

  function isValidEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
  function isValidPhone(v) { return (v.match(/\d/g) || []).length >= MIN_PHONE_DIGITS; }
  function isValidPostcode(v) { return UK_POSTCODE_RE.test(v.trim()); }

  function setError(msg) {
    const el = document.getElementById('rh-form-error');
    el.textContent = msg;
    el.style.display = msg ? 'block' : 'none';
  }

  const submitBtn   = document.getElementById('rh-submit');
  const submitArrow = document.getElementById('rh-submit-arrow');

  function checkFormReady() {
    const firstName = document.getElementById(FIELD.FIRST_NAME).value.trim();
    const lastName  = document.getElementById(FIELD.LAST_NAME).value.trim();
    const email     = document.getElementById(FIELD.EMAIL).value.trim();
    const phone     = document.getElementById(FIELD.PHONE).value.trim();
    const postcode  = document.getElementById(FIELD.POSTCODE).value.trim();
    const ready = Boolean(
      firstName && lastName && isValidEmail(email) && isValidPhone(phone) && isValidPostcode(postcode)
    );
    submitBtn.classList.toggle('is-ready', ready);
    submitArrow.classList.toggle('is-ready', ready);
  }

  [FIELD.FIRST_NAME, FIELD.LAST_NAME, FIELD.EMAIL, FIELD.PHONE, FIELD.POSTCODE].forEach(function (id) {
    const el = document.getElementById(id);
    if (el) el.addEventListener('input', checkFormReady);
  });

  document.getElementById('rh-contact-form').addEventListener('submit', function (e) {
    const firstName = document.getElementById(FIELD.FIRST_NAME).value.trim();
    const lastName  = document.getElementById(FIELD.LAST_NAME).value.trim();
    const email     = document.getElementById(FIELD.EMAIL).value.trim();
    const phone     = document.getElementById(FIELD.PHONE).value.trim();
    const postcode  = document.getElementById(FIELD.POSTCODE).value.trim();
    const comments  = document.getElementById(FIELD.COMMENTS).value.trim();

    if (!firstName || !lastName)    { e.preventDefault(); e.stopImmediatePropagation(); setError(translations.error_name); return; }
    if (!isValidEmail(email))       { e.preventDefault(); e.stopImmediatePropagation(); setError(translations.error_email); return; }
    if (!isValidPhone(phone))       { e.preventDefault(); e.stopImmediatePropagation(); setError(translations.error_phone); return; }
    if (!isValidPostcode(postcode)) { e.preventDefault(); e.stopImmediatePropagation(); setError(translations.error_postcode); return; }

    // Validation passed — build the email body and let the form submit naturally.
    // Shopify handles CAPTCHA then redirects back to ?step=4 where Liquid shows success.
    setError('');
    const hire = JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}');
    document.getElementById('rh-contact-name').value = firstName + ' ' + lastName;
    document.getElementById('rh-hidden-body').value = buildEmailBody(hire, firstName, lastName, phone, postcode, comments);

    submitBtn.disabled    = true;
    submitArrow.disabled  = true;
    submitBtn.textContent = translations.sending;
  });

  document.getElementById('rh-back-4').addEventListener('click', function () {
    const url = new URL(window.location.href);
    url.searchParams.set('step', '3');
    window.location.href = url.toString();
  });

  populateSummary();
};

export default initStepReview;
